export const activityTypeList = [
  'fi',
  'fl',
  'fw',
  'lo',
  'wa',
] as const;

export type ActivityType = (typeof activityTypeList)[number];
